import type { ReactNode, SVGProps } from 'react';

function svgIcon(children: ReactNode) {
  return (props: SVGProps<SVGSVGElement>) => {
    return (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.8}
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}>
        {children}
      </svg>
    );
  };
}

export const DashboardIcon = svgIcon(
  <>
    <path d="M4 11.5 12 4l8 7.5" />
    <path d="M6 10v9.5h12V10" />
    <path d="M10 19.5v-5h4v5" />
  </>
);

export const TasksIcon = svgIcon(
  <path d="M4 6.5l1.6 1.6L8.4 5M4 13l1.6 1.6L8.4 11.5M4 19.5l1.6 1.6L8.4 18M11.5 7h8.5M11.5 13.4h8.5M11.5 19.8h8.5" />
);

export const CasesIcon = svgIcon(
  <path d="M3 5h18v3.2H3zM4.5 8.2h15V20a1 1 0 0 1-1 1h-13a1 1 0 0 1-1-1zM9.5 12.5h5" />
);

export const ScanServicesIcon = svgIcon(
  <path d="M12 3l1.7 4.8L18.5 9.5l-4.8 1.7L12 16l-1.7-4.8L5.5 9.5l4.8-1.7zM18.5 15.5l.7 2 2 .7-2 .7-.7 2-.7-2-2-.7 2-.7z" />
);

export const OrdersIcon = svgIcon(
  <>
    <path d="M3 6.5h10v9H3zM13 9.5h4l3 3v3h-7z" />
    <circle cx="7" cy="17.5" r="1.6" />
    <circle cx="16.5" cy="17.5" r="1.6" />
  </>
);

export const PatientsIcon = svgIcon(
  <>
    <circle cx="9" cy="8" r="3" />
    <path d="M3.5 19.5v-1A4.5 4.5 0 0 1 8 14h2a4.5 4.5 0 0 1 4.5 4.5v1" />
    <path d="M16 5.6a3 3 0 0 1 0 5.8M16.5 14.2a4.5 4.5 0 0 1 4 4.3v1" />
  </>
);

export const FilesIcon = svgIcon(
  <path d="M5 3.5h9l4 4V20a.5.5 0 0 1-.5.5h-13A.5.5 0 0 1 5 20zM14 3.5V8h4" />
);

export const CheckGlyphIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={3.4}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}>
    <path d="m5 12 5 5L20 6" />
  </svg>
);

export const IndeterminateGlyphIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={3.4}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}>
    <path d="M6 12h12" />
  </svg>
);

export const ChevronDownIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}>
    <path d="m6 9 6 6 6-6" />
  </svg>
);

export const AiMarkIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" {...props}>
    <rect
      x="2.4"
      y="6.6"
      width="13.6"
      height="13.6"
      rx="2"
      stroke="currentColor"
      strokeWidth="1.7"
    />
    <text
      x="9.2"
      y="16.5"
      textAnchor="middle"
      fontSize="8.4"
      fontWeight="700"
      letterSpacing="-0.3"
      fill="currentColor">
      AI
    </text>
    <path
      d="M15.6 3.2c.35 2.3 1.1 3.05 3.4 3.4-2.3.35-3.05 1.1-3.4 3.4-.35-2.3-1.1-3.05-3.4-3.4 2.3-.35 3.05-1.1 3.4-3.4z"
      fill="currentColor"
      stroke="#fff"
      strokeWidth="2.4"
      strokeLinejoin="round"
      paintOrder="stroke"
    />
  </svg>
);
